export const environment = {
  production: true,
  apiUrl: 'https://moonraypharmaceuticals.com/'  // Make sure this is correct
};
